import { getTypedState } from 'ducks/hooks'

export const getPDFUrl = () => getTypedState().files?.pdfUrl ?? null

